import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_clipboard.svg'
import _imports_1 from '@/app/ui/assets/svg/delete.svg'
import _imports_2 from '@/app/ui/assets/svg/plus-active.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-08effff8")

_pushScopeId("data-v-08effff8")
const _hoisted_1 = {
  class: "bg-white border border-gray-lp-1400 rounded-xl p-3 text-xs text-gray-lp-300",
  "data-testid": "booking-repair-cipl-section"
}
const _hoisted_2 = { class: "flex flex-row items-center gap-2" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_0,
  alt: "clipboard"
}, null, -1)
const _hoisted_4 = {
  class: "text-20px font-semibold text-black-lp-300",
  "data-testid": "booking-repair-cipl-section-title"
}
const _hoisted_5 = { class: "py-3" }
const _hoisted_6 = {
  class: "border border-gray-lp-2100 rounded-md border-separate w-full",
  "data-testid": "booking-repair-cipl-list"
}
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = /*#__PURE__*/_createVNode("th", { class: "ml-3 mr-6 py-2 font-semibold w-7 border-b border-gray-lp-2100" }, " No ", -1)
const _hoisted_9 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"519px"}
}
const _hoisted_10 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"100px"}
}
const _hoisted_11 = {
  class: "mr-6 py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"190px"}
}
const _hoisted_12 = /*#__PURE__*/_createVNode("th", {
  class: "py-2 font-semibold border-b border-gray-lp-2100",
  style: {"width":"73px"}
}, null, -1)
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_15 = { class: "flex flex-row ml-1" }
const _hoisted_16 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_17 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_18 = { class: "flex flex-row ml-1" }
const _hoisted_19 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_20 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "plus",
  style: {"width":"18px","height":"18px"}
}, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  class: "px-3 py-1.5 border-t border-gray-lp-2100",
  colspan: "5"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("img", {
  class: "w-5 h-5",
  src: _imports_2,
  alt: "plus"
}, null, -1)
const _hoisted_25 = { class: "flex flex-row gap-3" }
const _hoisted_26 = { class: "flex-col gap-3 flex w-full" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "w-full" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_ModalAllCommodity = _resolveComponent("ModalAllCommodity")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("section", _hoisted_2, [
        _hoisted_3,
        _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.getTranslationText("title")), 1)
      ]),
      _createVNode("section", _hoisted_5, [
        _createVNode(_component_DataWrapper, {
          class: "text-xs",
          label: _ctx.getTranslationText('CIPLLabel'),
          optional: false,
          isDefault: false
        }, null, 8, ["label"]),
        _createVNode("table", _hoisted_6, [
          _createVNode("thead", null, [
            _createVNode("tr", _hoisted_7, [
              _hoisted_8,
              _createVNode("th", _hoisted_9, _toDisplayString(_ctx.getTranslationText("itemDetailCIPLHeadingText")), 1),
              _createVNode("th", _hoisted_10, _toDisplayString(_ctx.getTranslationText("quantityCIPLHeadingText")), 1),
              _createVNode("th", _hoisted_11, _toDisplayString(_ctx.getTranslationText("itemPriceCIPLHeadingText")), 1),
              _hoisted_12
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listCommodityCIPL, (cipl, index) => {
            return (_openBlock(), _createBlock("tr", {
              key: cipl.id,
              class: "list-complete-item"
            }, [
              _createVNode("td", {
                class: ["pl-3 pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                _createVNode("div", _hoisted_13, _toDisplayString(index + 1), 1)
              ], 2),
              _createVNode("td", {
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_SelectSearch, {
                      key: 0,
                      ref: `inputCommodity${index}`,
                      "data-testid": `booking-repair-cipl-row-${index}-input-detail`,
                      class: "mt-1.5",
                      options: _ctx.commodities,
                      isLoading: _ctx.isLoadingCommodity,
                      keyName: "name",
                      keyValue: "code",
                      placeholder: _ctx.getTranslationText('commodityPlaceholder'),
                      modelValue: cipl.commodity,
                      "onUpdate:modelValue": [($event: any) => (cipl.commodity = $event), ($event: any) => (_ctx.validateCIPLCommodity(index))],
                      isShowErrorIndicator: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][0],
                  cipl.indexCommodity
                )
              ,
                      errorCaption: 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][0],
                  cipl.indexCommodity
                )
              ,
                      maxHeight: "270px",
                      useInfiniteScroll: "",
                      idInput: "commodity-booking",
                      autoUpDown: "",
                      isViewAll: "",
                      serverSide: false,
                      onClickViewAll: ($event: any) => (_ctx.clickViewAll(index)),
                      onScrolled: _ctx.handleScrolledCommodity,
                      onChange: ($event: any) => (_ctx.changeCommodities($event, index)),
                      onFocus: ($event: any) => (_ctx.onFocusCommodityList(index)),
                      onFilter: ($event: any) => (_ctx.handleInputCommodity($event, index)),
                      notClearValue: true
                    }, {
                      "custom-option": _withId(({ item }) => [
                        _createVNode("div", _hoisted_14, [
                          _createVNode("div", null, _toDisplayString(item.name), 1),
                          _createVNode("div", _hoisted_15, [
                            (item.isQuarantine)
                              ? (_openBlock(), _createBlock("span", _hoisted_16, " K "))
                              : _createCommentVNode("", true),
                            (item.isDangerousGoods)
                              ? (_openBlock(), _createBlock("span", _hoisted_17, " DG "))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      "selected-info": _withId(({ selected }) => [
                        _createVNode("div", _hoisted_18, [
                          (selected && selected.isQuarantine)
                            ? (_openBlock(), _createBlock("span", _hoisted_19, " K "))
                            : _createCommentVNode("", true),
                          (selected && selected.isDangerousGoods)
                            ? (_openBlock(), _createBlock("span", _hoisted_20, " DG "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "options", "isLoading", "placeholder", "modelValue", "onUpdate:modelValue", "isShowErrorIndicator", "errorCaption", "onClickViewAll", "onScrolled", "onChange", "onFocus", "onFilter"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                id: "cipl-quantity-wrapper",
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      "data-testid": `booking-repair-cipl-row-${index}-input-quantity`,
                      id: "cipl-quantity",
                      class: "cipl-quantity",
                      format: _ctx.formatCIPLQuantityNomorOnly,
                      modelValue: cipl.quantity,
                      "onUpdate:modelValue": [($event: any) => (cipl.quantity = $event), ($event: any) => (_ctx.validateCIPLQuantity(index))],
                      placeholder: "0",
                      error: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][1],
                  cipl.indexQuantity
                )
              ,
                      "error-caption": 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][1],
                  cipl.indexQuantity
                )
              ,
                      onFocus: ($event: any) => (_ctx.updateFIeldIndex(cipl.indexQuantity))
                    }, null, 8, ["data-testid", "format", "modelValue", "onUpdate:modelValue", "error", "error-caption", "onFocus"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                id: "cipl-goods-price-wrapper",
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                (!!_ctx.error.listCommodityCIPLDocInternational[index])
                  ? (_openBlock(), _createBlock(_component_lp_input, {
                      key: 0,
                      "data-testid": `booking-repair-cipl-row-${index}-input-price`,
                      id: "cipl-goods-price",
                      class: "cipl-goods-price",
                      placeholder: "0",
                      modelValue: cipl.goodsPrice,
                      "onUpdate:modelValue": [($event: any) => (cipl.goodsPrice = $event), ($event: any) => (_ctx.validateCIPLGoodsPrice(index))],
                      format: _ctx.formatCIPLGoodsPrice,
                      prefix: 
                _ctx.isEditSttMY ? 'RM' : _ctx.getTranslationText('goodsPricePrefix')
              ,
                      error: 
                !!_ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][2],
                  cipl.indexGoodsPrice
                )
              ,
                      "error-caption": 
                _ctx.decideShowError(
                  _ctx.error.listCommodityCIPLDocInternational[index][2],
                  cipl.indexGoodsPrice
                )
              ,
                      onFocus: ($event: any) => (_ctx.updateFIeldIndex(cipl.indexGoodsPrice)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"]))
                    }, null, 8, ["data-testid", "modelValue", "onUpdate:modelValue", "format", "prefix", "error", "error-caption", "onFocus"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("td", {
                class: ["pr-6", _ctx.decideBorderBottomTableColumn(index)]
              }, [
                _withDirectives(_createVNode("button", {
                  "data-testid": `booking-repair-cipl-row-${index}-button-delete`,
                  class: "text-red-lp-100 font-semibold flex flex-row gap-2 items-center mt-4",
                  onClick: () => _ctx.onDeleteCIPL(index)
                }, [
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.getTranslationText("deleteCIPLBtnText")), 1)
                ], 8, ["data-testid", "onClick"]), [
                  [_vShow, _ctx.listCommodityCIPL.length > 1]
                ])
              ], 2)
            ]))
          }), 128)),
          (_ctx.listCommodityCIPL.length < _ctx.maxCipl)
            ? (_openBlock(), _createBlock("tr", _hoisted_22, [
                _createVNode("td", _hoisted_23, [
                  _createVNode("button", {
                    class: "text-red-lp-100 font-semibold flex flex-row gap-2 items-center",
                    "data-testid": "booking-repair-cipl-button-add-item",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddCIPL && _ctx.onAddCIPL(...args)))
                  }, [
                    _hoisted_24,
                    _createTextVNode(" " + _toDisplayString(_ctx.getTranslationText("addCIPLBtnText")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("section", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_DataWrapper, {
            class: "text-xs w-full",
            label: _ctx.getTranslationText('emailLabel'),
            id: "doc-international-input-wrapper",
            optional: true
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                "data-testid": "booking-repair-cipl-input-email",
                class: "w-full",
                placeholder: _ctx.getTranslationText('emailPlaceholder'),
                modelValue: _ctx.modelValue.email,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.email = $event)),
                  _ctx.validateEmail
                ],
                maxLength: 100,
                error: !!_ctx.decideShowError(_ctx.error.emailDocInternational, _ctx.indexEmail),
                "error-caption": 
              _ctx.decideShowError(_ctx.error.emailDocInternational, _ctx.indexEmail)
            ,
                onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexEmail)))
              }, null, 8, ["placeholder", "modelValue", "error", "error-caption", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "text-xs w-full",
            label: _ctx.getTranslationText('idNumberLabel'),
            id: "doc-international-input-wrapper",
            optional: true
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                "data-testid": "booking-repair-cipl-input-identity",
                class: "w-full",
                modelValue: _ctx.modelValue.idNumber,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.idNumber = $event)),
                  _ctx.validateIdNumber
                ],
                format: _ctx.formatCIPLQuantity,
                placeholder: _ctx.getTranslationText('idNumberPlaceholder'),
                maxLength: 100,
                error: 
              !!_ctx.decideShowError(_ctx.error.idNumberDocInternational, _ctx.indexIdNumber)
            ,
                errorCaption: 
              _ctx.decideShowError(_ctx.error.idNumberDocInternational, _ctx.indexIdNumber)
            ,
                onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexIdNumber)))
              }, null, 8, ["modelValue", "format", "placeholder", "error", "errorCaption", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            class: "text-xs w-full",
            label: _ctx.getTranslationText('taxNumberLabel'),
            id: "doc-international-input-wrapper",
            optional: true
          }, {
            default: _withId(() => [
              _createVNode(_component_LpInput, {
                id: "doc-international-input",
                "data-testid": "booking-repair-cipl-input-tax",
                class: "w-full",
                modelValue: _ctx.modelValue.taxNumber,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.taxNumber = $event)),
                  _ctx.validateTaxNumber
                ],
                placeholder: _ctx.getTranslationText('taxNumberPlaceholder'),
                format: _ctx.formatCIPLQuantity,
                error: 
              !!_ctx.decideShowError(_ctx.error.taxNumberDocInternational, _ctx.indexTaxNumber)
            ,
                errorCaption: 
              _ctx.decideShowError(_ctx.error.taxNumberDocInternational, _ctx.indexTaxNumber)
            ,
                onFocus: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateFIeldIndex(_ctx.indexTaxNumber)))
              }, null, 8, ["modelValue", "placeholder", "format", "error", "errorCaption", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _hoisted_27
      ])
    ]),
    (_ctx.isModalViewAll)
      ? (_openBlock(), _createBlock(_component_ModalAllCommodity, {
          key: 0,
          onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isModalViewAll = false)),
          onChange: _ctx.onChooseCommodity
        }, null, 8, ["onChange"]))
      : _createCommentVNode("", true)
  ], 64))
})